// import external dependencies
import 'jquery';
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
    this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
  },
};
import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox';
import 'mixitup/dist/mixitup.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import gallery from './routes/gallery';
import postTypeArchiveDownload from './routes/downloads';
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faChevronDown, faCaretLeft, faCaretRight, faArrowRight, faTimes, faShareAlt, faCheckSquare, faMobile, faPhoneVolume, faEnvelopeOpenText, faPoundSign, faSearchPlus} from '@fortawesome/pro-solid-svg-icons';
import { faFacebook, faFacebookF, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin } from '@fortawesome/free-brands-svg-icons';
config.searchPseudoElements=true;
library.add(faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faFacebook, faFacebookF, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin, faChevronDown, faCaretLeft, faCaretRight, faArrowRight, faTimes, faShareAlt, faCheckSquare, faMobile, faPhoneVolume, faEnvelopeOpenText, faPoundSign, faSearchPlus);
dom.i2svg();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  gallery,
  postTypeArchiveDownload,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// import './icaal-contact-form-v2-public.js';
// import './icaal-contact-form-v2-addalert.js';
import './form.js';



// WEBPACK FOOTER //
// ./scripts/main.js